import React from "react";
import "./BirthCertImp.css";
const BirthCertImp = () => {
  return (
    <div className="birthCertImpContainer">
      <h1>Importance of Birth Certificate <span>Attestation</span> in Bangalore</h1>
      <p>
        Birth certificate attestation in Bangalore is an international strategy
        that helps to prove the realness of a certificate. It is a mandatory
        procedure while traveling outside the country. Birth certificate
        attestation helps in making foreign travel quicker without any legal
        issues and acquiring your purposes easily. It also assists the
        authorities of destination countries in understanding the age and
        identity of the immigrant. This authentication process enhances the
        estimation of the certificate. Concerned authorities in the destination
        country play a major role in the attestation procedure. Birth
        certificate attestation in Bangalore makes the document more credible
        and real. The authorities check the documents thoroughly before the
        procedure of birth certificate attestation is completed.
      </p>
    </div>
  );
};

export default BirthCertImp;
